export default "__VITE_ASSET__CyywPPFm__"